<form [formGroup]="form" (submit)="handleSubmit($event)">
  <div class="form-wrapper">
    <mat-form-field>
      <mat-label>New Password</mat-label>
      <input
        matInput
        type="password"
        name="newPassword"
        formControlName="password"
        autocomplete="new-password"
        required
      />

      @if (password.errors?.required) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        Password is required.
      </mat-error>
      } @if (password.dirty && password.errors?.isShort) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must have at least 8 characters.
      </mat-error>
      } @if (password.dirty && password.errors?.atLeastOneNumber) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must include at least 1 number.
      </mat-error>
      } @if (password.dirty && password.errors?.atLeastOneUpperCase) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must include at least 1 upper case letter.
      </mat-error>
      } @if (password.dirty && password.errors?.atLeastOneLowerCase) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must include at least 1 lower case letter.
      </mat-error>
      } @if (password.dirty && password.errors?.notIncludeFromEmailAddress) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password must not include a sequence of three or more characters from your email address (before the &#64;
        symbol)
      </mat-error>
      } @if (password.dirty && password.errors?.characterInvalid) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The password only can include (#,$,%,&,&#64;,!) symbols.
      </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Confirm Password</mat-label>
      <input
        matInput
        type="password"
        name="confirmPassword"
        autocomplete="new-password"
        formControlName="passwordConfirm"
        pattern="{{ password.value | escapeChars }}"
        required
      />

      @if (passwordConfirm.errors?.required) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        Password is required.
      </mat-error>
      } @if (password.dirty && password.touched && passwordConfirm.errors?.pattern) {
      <mat-error>
        <fa-icon icon="exclamation-triangle"></fa-icon>
        The passwords must be the same.
      </mat-error>
      }
    </mat-form-field>

    <button type="submit" hidden></button>
  </div>
</form>
